<template>
  <div id="page-user-edit">
    <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.userId }} not found. </span>
      <span>
        <span>Check </span
        ><router-link :to="{ name: 'Engineer List' }" class="text-inherit underline"
          >All Users</router-link
        >
      </span>
    </vs-alert>

    <vx-card v-if="transaction_data" class="paymentRequestCard">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Billing" icon-pack="feather" icon="icon-credit-card">
            <div class="tab-text">
              <payment-request-tab-billing class="mt-4" :userData="transaction_data" />
            </div>
          </vs-tab>
          <vs-tab label="Personal Information" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <payment-request-tab-personal-info class="mt-4" :userData="transaction_data" />
            </div>
          </vs-tab>
          <vs-tab label="Selfies" icon-pack="feather" icon="icon-image">
            <div class="tab-text">
              <payment-request-tab-selfies class="mt-4" :data="transaction_data" />
            </div>
          </vs-tab>
          <vs-tab label="Payment Information" icon-pack="feather" icon="icon-credit-card">
            <div class="tab-text">
              <payment-request-tab-payment-info class="mt-4" :userData="transaction_data" />
            </div>
          </vs-tab>
          <vs-tab label="ID Information" icon-pack="feather" icon="icon-user-check">
            <div class="tab-text">
              <payment-request-tab-i-d-info class="mt-4" :userData="transaction_data" />
            </div>
          </vs-tab>
          <vs-tab label="Legal Information" icon-pack="feather" icon="icon-pocket">
            <div class="tab-text">
              <payment-request-tab-legal-info class="mt-4" :userData="transaction_data" />
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>
    <!-- <vs-tab label="Left">
        left
        <vs-tabs position="left" color="danger">
          <vs-tab label="Home">
            <span>Jujubes ....</span>
          </vs-tab>
          <vs-tab label="Service">
            <span>Halvah ....</span>
          </vs-tab>
          <vs-tab label="login">
            <span>Chocolate .....</span>
          </vs-tab>
          <vs-tab :disabled="true" label="Disabled">
            <div>Macaroon .....</div>
          </vs-tab>
        </vs-tabs>
      </vs-tab> -->
  </div>
</template>

<script>
import PaymentRequestTabPersonalInfo from "./PaymentRequestTabPersonalInfo.vue";
import PaymentRequestTabBilling from "./PaymentRequestTabBilling.vue";
import PaymentRequestTabSelfies from "./PaymentRequestTabSelfies.vue";
import PaymentRequestTabPaymentInfo from "./PaymentRequestTabPaymentInfo.vue";
import PaymentRequestTabIDInfo from "./PaymentRequestTabIDInfo.vue";
import PaymentRequestTabLegalInfo from "./PaymentRequestTabLegalInfo.vue";

// Store Module
import moduleUserManagement from "@/store/user-management/moduleUserManagement.js";

export default {
  components: {
    PaymentRequestTabPersonalInfo,
    PaymentRequestTabBilling,
    PaymentRequestTabSelfies,
    PaymentRequestTabPaymentInfo,
    PaymentRequestTabIDInfo,
    PaymentRequestTabLegalInfo
  },
  data() {
    return {
      transaction_data: null,
      user_not_found: false,
      activeTab: 0
    }
  },
  watch: {
    activeTab() {
      this.fetch_transaction_data(this.$route.params.transactionId);
    },
  },
  methods: {
    fetch_transaction_data(transactionId) {
      this.$store
        .dispatch('userManagement/fetchUserTransaction', transactionId)
        .then((res) => {
          this.transaction_data = res.data.transaction;
        })
        .catch((err) => {
          this.user_not_found = true;
          return;
          console.error(err);
        });
    },
  },
  created () {
    // Register Module UserManagement Module
    if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }
    this.fetch_transaction_data(this.$route.params.transactionId)
  },
  beforeCreate () {
    if (!this.$store.state.auth.isUserLoggedIn()) this.$router.push('/login')
    //  User Reward Card
  }
}
</script>

<style>
.paymentRequestCard {
  height: 800px;
  @media only screen and (max-width:800px){
    height: auto
    
  }
}
</style>